let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("deIvc")).then(() => parcelRequire('bf3fm'));